import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-hot-toast";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { DropdownMenuLabel } from "@radix-ui/react-dropdown-menu";
import { Check, Sun } from "lucide-react";
import SharedDataContext from "../../SharedDataContext";
import { setActiveWorkspace } from "../../apis/ext";
import { useCaptureEvent } from "../../hooks/useCaptureEvent";
import Image from "../Tags/Image";
import usePageAttributes from "../../hooks/usePageAttributes";
import { useTheme } from "../ThemeProvider";

export default function Header({ homeLink = "/contact-viewer/" }) {
  const { logo, appname, setTitle } = usePageAttributes();
  const { theme, setTheme } = useTheme();
  const captureEvent = useCaptureEvent();
  const { userData, params } = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const workspaces = userData?.workspaces?.data || [];
  const [searchQuery, setSearchQuery] = useState("");
  const hasManyWorkspaces = workspaces && workspaces.length > 5;
  const filteredWorkspaces = hasManyWorkspaces
    ? workspaces.filter((workspace) =>
        workspace.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : workspaces;
  const setActiveWorkspaceFn = useMutation(setActiveWorkspace, {
    onSuccess(data, variables, context) {
      if (window && typeof window !== "undefined") {
        window.parent.postMessage("RELOAD_WEBSITE", "*");
      }
      toast.success(data.message);
    },
  });
  const switchWorkspace = (id) => {
    setActiveWorkspaceFn.mutate(id);
  };

  return (
    <div
      className={`flex px-3  py-5 justify-between items-center  bg-background ${
        params && params.source === "app" && "hidden"
      }`}
    >
      <Link to={homeLink}>
        {/* <Image className="no-invert"
          src={`/images/ext/logo/${process.env.REACT_APP_APP_LOGO}.svg`}
          alt="Logo"
          width={120}
          onClick={() => {
            if (homeLink === "/contact-viewer/bulk-profiles") {
              setTimeout(() => {
                const newevent = new CustomEvent("load_bulk_page", {
                  detail: true,
                });
                window.dispatchEvent(newevent);
              }, 500);
            }
          }}
          className="no-invert"
        /> */}
        {appname === "PrimeRole" ? (
          <>
            {theme === "dark" ? (
              <Image
                src="/images/apps/primerole/logo-dark.svg"
                className="logo no-invert w-[120px]"
                alt="Logo"
                width={120}
                onClick={() => {
                  if (homeLink === "/contact-viewer/bulk-profiles") {
                    setTimeout(() => {
                      const newevent = new CustomEvent("load_bulk_page", {
                        detail: true,
                      });
                      window.dispatchEvent(newevent);
                    }, 500);
                  }
                }}
              />
            ) : (
              <Image
                src={logo}
                className="logo no-invert w-[120px]"
                alt="Logo"
                width={120}
                onClick={() => {
                  if (homeLink === "/contact-viewer/bulk-profiles") {
                    setTimeout(() => {
                      const newevent = new CustomEvent("load_bulk_page", {
                        detail: true,
                      });
                      window.dispatchEvent(newevent);
                    }, 500);
                  }
                }}
              />
            )}
          </>
        ) : (
          <Image
            src={logo}
            className="logo no-invert w-[120px]"
            alt="Logo"
            width={120}
            onClick={() => {
              if (homeLink === "/contact-viewer/bulk-profiles") {
                setTimeout(() => {
                  const newevent = new CustomEvent("load_bulk_page", {
                    detail: true,
                  });
                  window.dispatchEvent(newevent);
                }, 500);
              }
            }}
          />
        )}
      </Link>

      <div className="inline-flex">
        {activeWorkspace &&
        userData &&
        userData.workspaces &&
        workspaces &&
        workspaces.length > 0 ? (
          <DropdownMenu>
            <DropdownMenuTrigger className="inline-flex items-center focus:outline-none text-sm">
              <Image
                nobaseurl={activeWorkspace.icon ? true : false}
                src={activeWorkspace.icon ? activeWorkspace.icon : "/images/ext/org-new.svg"}
                height={16}
                width={16}
                className="mr-1.5 no-invert rounded-full"
              />{" "}
              <span>{activeWorkspace.name}</span> <ChevronDownIcon className="ml-2" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="min-w-56 rounded-[14px] p-2" align="end">
              {!params.source || params.source !== "salesforce" ? (
                <div className="flex items-center justify-between mb-3">
                  <DropdownMenuLabel className="p-2 pb-1 text-[14px] font-semibold text-gray-400 flex items-center space-x-2">
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3337 11.7786H2.66699M2.66699 11.7786L5.33366 9.11198M2.66699 11.7786L5.33366 14.4453M2.66699 5.11198H13.3337M13.3337 5.11198L10.667 2.44531M13.3337 5.11198L10.667 7.77865"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span> Switch to</span>
                  </DropdownMenuLabel>
                  <span className="flex">
                    {/* <span
                      className="w-full inline-flex items-center"
                      onClick={() => {
                        if (theme === "light") {
                          setTheme("dark");
                        }
                        if (theme === "dark") {
                          setTheme("light");
                        }
                        captureEvent("TOP_ThemeBtn");
                      }}
                    >
                      {theme === "light" && (
                        <span className="cursor-pointer transition-all text-text-700 mr-1 ">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              d="M18.3333 13.2035C17.2388 13.6985 16.0239 13.974 14.7446 13.974C9.92941 13.974 6.02597 10.0706 6.02597 5.25544C6.02597 3.97612 6.30151 2.76115 6.79648 1.66666C3.77147 3.03468 1.66667 6.07891 1.66667 9.61473C1.66667 14.4299 5.57012 18.3333 10.3853 18.3333C13.9211 18.3333 16.9653 16.2285 18.3333 13.2035Z"
                              stroke="currentColor"
                              stroke-width="1.66667"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      )}
                      {theme === "dark" && <Sun className="h-4 w-4 cursor-pointer transition-all mr-1" />}
                    </span> */}
                  </span>
                </div>
              ) : (
                <p className="pb-1.5"></p>
              )}
              {!params.source && hasManyWorkspaces && (
                <div className="px-2 pb-2">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search workspace"
                    className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-text-700 placeholder:text-gray-500 focus:outline-none focus:ring-1 focus:ring-border"
                  />
                </div>
              )}
              {(!params.source || params.source !== "salesforce") && (
                <div className={`${hasManyWorkspaces ? "max-h-64 overflow-y-auto" : ""}`}>
                  {filteredWorkspaces.map((workspace) => (
                    <DropdownMenuItem
                      onClick={() => {
                        if (activeWorkspace.id !== workspace.id) {
                          switchWorkspace(workspace.id);
                          captureEvent("EXU_UserProfile_SwitchToBtn");
                        }
                      }}
                      className={`flex justify-between py-1 ${
                        activeWorkspace.id !== workspace.id && "cursor-pointer"
                      } items-center text-gray-700 text-sm`}
                    >
                      <span>
                        <span className="inline-flex items-center flex-wrap">
                          <Image
                            src={workspace.icon ? workspace.icon : "/images/ext/org-new.svg"}
                            height={16}
                            width={16}
                            className="mr-2 no-invert rounded-sm"
                            nobaseurl={workspace.icon ? true : false}
                          />{" "}
                          {workspace.name}
                        </span>
                      </span>
                      {activeWorkspace.id === workspace.id && <Check width={14} height={14} />}
                    </DropdownMenuItem>
                  ))}
                </div>
              )}
              {params.source && params.source === "salesforce" && (
                <DropdownMenuItem className="flex justify-between py-1 cursor-default items-center text-text-700 text-sm">
                  <span>
                    <span className="inline-flex items-center flex-wrap">
                      <Image
                        src={activeWorkspace.icon ? activeWorkspace.icon : "/images/ext/org-new.svg"}
                        height={16}
                        width={16}
                        className="mr-2 no-invert"
                      />{" "}
                      {activeWorkspace.name}
                    </span>
                  </span>
                  <Check width={14} height={14} />
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuLabel className="p-3 text-[13px] font-semibold">
                {userData?.name}
              </DropdownMenuLabel>
              <DropdownMenuItem className="py-0">
                <Link
                  to={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}`}
                  className="w-full flex items-center py-2.5"
                  target="_blank"
                  onClick={() => {
                    captureEvent("EXU_UserProfile_DashboardBtn");
                  }}
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.33333 11.7791H10.6667M7.34513 2.28847L2.82359 5.80522C2.52135 6.0403 2.37022 6.15784 2.26135 6.30504C2.16491 6.43543 2.09307 6.58232 2.04935 6.7385C2 6.91481 2 7.10626 2 7.48917V12.3125C2 13.0592 2 13.4326 2.14532 13.7178C2.27316 13.9687 2.47713 14.1726 2.72801 14.3005C3.01323 14.4458 3.3866 14.4458 4.13333 14.4458H11.8667C12.6134 14.4458 12.9868 14.4458 13.272 14.3005C13.5229 14.1726 13.7268 13.9687 13.8547 13.7178C14 13.4326 14 13.0592 14 12.3125V7.48917C14 7.10626 14 6.91481 13.9506 6.7385C13.9069 6.58232 13.8351 6.43543 13.7386 6.30504C13.6298 6.15784 13.4787 6.0403 13.1764 5.80522L8.65487 2.28847C8.42065 2.1063 8.30354 2.01521 8.17423 1.9802C8.06013 1.94931 7.93987 1.94931 7.82577 1.9802C7.69646 2.01521 7.57935 2.1063 7.34513 2.28847Z"
                      stroke="var(--gray-500)"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span className="ml-2">Dashboard</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem className="py-0">
                <Link
                  to={"/contact-viewer/profile"}
                  className="w-full flex items-center py-2.5"
                  onClick={() => {
                    captureEvent("EXU_UserProfile_PreferencesBtn");
                  }}
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99967 10.446C9.10424 10.446 9.99967 9.55053 9.99967 8.44596C9.99967 7.34139 9.10424 6.44596 7.99967 6.44596C6.89511 6.44596 5.99967 7.34139 5.99967 8.44596C5.99967 9.55053 6.89511 10.446 7.99967 10.446Z"
                      stroke="var(--gray-500)"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.4845 10.2641C12.4038 10.4469 12.3798 10.6497 12.4154 10.8463C12.4511 11.0429 12.5448 11.2243 12.6845 11.3672L12.7209 11.4035C12.8336 11.5161 12.923 11.6498 12.984 11.7969C13.045 11.9441 13.0764 12.1018 13.0764 12.2611C13.0764 12.4204 13.045 12.5781 12.984 12.7253C12.923 12.8724 12.8336 13.0061 12.7209 13.1187C12.6083 13.2314 12.4746 13.3208 12.3275 13.3818C12.1803 13.4428 12.0226 13.4742 11.8633 13.4742C11.704 13.4742 11.5463 13.4428 11.3991 13.3818C11.252 13.3208 11.1183 13.2314 11.0057 13.1187L10.9694 13.0823C10.8265 12.9426 10.6451 12.8489 10.4485 12.8132C10.2519 12.7776 10.0491 12.8017 9.86634 12.8823C9.68709 12.9592 9.53421 13.0867 9.42653 13.2493C9.31885 13.4119 9.26106 13.6025 9.26028 13.7975V13.9005C9.26028 14.222 9.13258 14.5303 8.90526 14.7576C8.67794 14.9849 8.36963 15.1126 8.04816 15.1126C7.72668 15.1126 7.41838 14.9849 7.19106 14.7576C6.96374 14.5303 6.83604 14.222 6.83604 13.9005V13.846C6.83135 13.6454 6.76641 13.4508 6.64968 13.2876C6.53295 13.1244 6.36982 13.0001 6.18149 12.9308C5.9987 12.8501 5.79592 12.8261 5.59932 12.8617C5.40271 12.8974 5.2213 12.9911 5.07846 13.1308L5.0421 13.1672C4.92953 13.2799 4.79584 13.3693 4.64869 13.4303C4.50154 13.4913 4.34381 13.5227 4.18452 13.5227C4.02523 13.5227 3.8675 13.4913 3.72035 13.4303C3.5732 13.3693 3.43952 13.2799 3.32695 13.1672C3.21425 13.0546 3.12484 12.9209 3.06384 12.7738C3.00285 12.6266 2.97145 12.4689 2.97145 12.3096C2.97145 12.1503 3.00285 11.9926 3.06384 11.8454C3.12484 11.6983 3.21425 11.5646 3.32695 11.452L3.36331 11.4157C3.50303 11.2728 3.59676 11.0914 3.6324 10.8948C3.66805 10.6982 3.64399 10.4954 3.56331 10.3126C3.48648 10.1334 3.35892 9.9805 3.19632 9.87282C3.03372 9.76513 2.84318 9.70735 2.64816 9.70657H2.54513C2.22365 9.70657 1.91535 9.57886 1.68803 9.35155C1.46071 9.12423 1.33301 8.81592 1.33301 8.49445C1.33301 8.17297 1.46071 7.86467 1.68803 7.63735C1.91535 7.41003 2.22365 7.28233 2.54513 7.28233H2.59967C2.80028 7.27763 2.99483 7.2127 3.15804 7.09597C3.32125 6.97924 3.44556 6.81611 3.51483 6.62778C3.5955 6.44498 3.61957 6.24221 3.58392 6.04561C3.54827 5.849 3.45455 5.66759 3.31483 5.52475L3.27846 5.48839C3.16576 5.37581 3.07636 5.24213 3.01536 5.09498C2.95436 4.94783 2.92296 4.7901 2.92296 4.63081C2.92296 4.47152 2.95436 4.31379 3.01536 4.16664C3.07636 4.01949 3.16576 3.88581 3.27846 3.77324C3.39104 3.66054 3.52472 3.57113 3.67187 3.51013C3.81902 3.44913 3.97675 3.41774 4.13604 3.41774C4.29533 3.41774 4.45306 3.44913 4.60021 3.51013C4.74736 3.57113 4.88104 3.66054 4.99361 3.77324L5.02998 3.8096C5.17281 3.94932 5.35423 4.04305 5.55083 4.07869C5.74744 4.11434 5.95021 4.09028 6.13301 4.0096H6.18149C6.36075 3.93277 6.51362 3.80521 6.62131 3.64261C6.72899 3.48001 6.78678 3.28947 6.78755 3.09445V2.99142C6.78755 2.66994 6.91526 2.36164 7.14258 2.13432C7.36989 1.907 7.6782 1.7793 7.99967 1.7793C8.32115 1.7793 8.62946 1.907 8.85677 2.13432C9.08409 2.36164 9.2118 2.66994 9.2118 2.99142V3.04596C9.21257 3.24099 9.27036 3.43152 9.37804 3.59412C9.48573 3.75672 9.6386 3.88429 9.81786 3.96112C10.0007 4.04179 10.2034 4.06586 10.4 4.03021C10.5966 3.99456 10.7781 3.90083 10.9209 3.76112L10.9573 3.72475C11.0698 3.61205 11.2035 3.52265 11.3507 3.46165C11.4978 3.40065 11.6555 3.36925 11.8148 3.36925C11.9741 3.36925 12.1318 3.40065 12.279 3.46165C12.4261 3.52265 12.5598 3.61205 12.6724 3.72475C12.7851 3.83732 12.8745 3.97101 12.9355 4.11816C12.9965 4.26531 13.0279 4.42304 13.0279 4.58233C13.0279 4.74162 12.9965 4.89935 12.9355 5.0465C12.8745 5.19365 12.7851 5.32733 12.6724 5.4399L12.636 5.47627C12.4963 5.6191 12.4026 5.80052 12.3669 5.99712C12.3313 6.19373 12.3554 6.3965 12.436 6.5793V6.62778C12.5129 6.80704 12.6404 6.95991 12.803 7.0676C12.9656 7.17528 13.1562 7.23306 13.3512 7.23384H13.4542C13.7757 7.23384 14.084 7.36155 14.3113 7.58886C14.5386 7.81618 14.6663 8.12449 14.6663 8.44596C14.6663 8.76744 14.5386 9.07575 14.3113 9.30306C14.084 9.53038 13.7757 9.65809 13.4542 9.65809H13.3997C13.2047 9.65886 13.0141 9.71665 12.8515 9.82433C12.6889 9.93201 12.5613 10.0849 12.4845 10.2641Z"
                      stroke="var(--gray-500)"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="ml-2">Preferences</span>
                </Link>
              </DropdownMenuItem>

              {(!params.source || params.source !== "salesforce") && (
                <>
                  <DropdownMenuSeparator />

                  <DropdownMenuItem className="cursor-pointer py-2">
                    <a
                      href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/logout`}
                      className="flex items-center"
                      target="_blank"
                      onClick={() => {
                        captureEvent("EXU_UserProfile_LogOutBtn");
                      }}
                    >
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.6667 11.7786L14 8.44531M14 8.44531L10.6667 5.11198M14 8.44531H6M6 2.44531H5.2C4.0799 2.44531 3.51984 2.44531 3.09202 2.6633C2.7157 2.85505 2.40973 3.16101 2.21799 3.53733C2 3.96515 2 4.52521 2 5.64531V11.2453C2 12.3654 2 12.9255 2.21799 13.3533C2.40973 13.7296 2.71569 14.0356 3.09202 14.2273C3.51984 14.4453 4.0799 14.4453 5.2 14.4453H6"
                          stroke="var(--gray-500)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="ml-2">Logout</span>
                    </a>
                  </DropdownMenuItem>
                </>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null}
      </div>
    </div>
  );
}
